import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as AccordionIconOpened } from './icons/AccordionIconOpened.svg';
import { ReactComponent as AccordionIconClosed } from './icons/AccordionIconClosed.svg';

import { StyledAccordion, StyledHeader, StyledTitle, StyledBody } from './styled';

function Accordion(props) {
  const {
    titulo,
    isRequired,
    children,
    isAlwaysOpen = false,
    disabled = false,
    borderColor = '#f38a00',
    textColor = '#f38a00',
    defaultOpen = false,
  } = props;

  const [isOpen, setIsOpen] = useState(isAlwaysOpen || isRequired || defaultOpen);

  const toggle = () => {
    if (!isAlwaysOpen && !disabled) {
      setIsOpen(prevState => !prevState);
    }
  };

  return (
    <StyledAccordion {...props}>
      <StyledHeader onClick={toggle} disabledCursor={disabled} borderColor={borderColor} textColor={textColor}>
        <StyledTitle textColor={textColor}>
          {titulo} {isRequired && '*'}
        </StyledTitle>
        {!isAlwaysOpen &&
          (isOpen ? <AccordionIconOpened width={10} height={10} /> : <AccordionIconClosed width={10} height={10} />)}
      </StyledHeader>
      <StyledBody isOpen={isOpen}>{children}</StyledBody>
    </StyledAccordion>
  );
}

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  children: PropTypes.node,
};

Accordion.defaultProps = {
  title: '',
  isRequired: false,
};

export default Accordion;
